import { borderFlagsBottom, borderFlagsLeft, borderFlagsRight, borderFlagsTop } from "./table";

// Represents a table border
export default class TableBorder {
  constructor () {
  /**
   * @type {SVGGElement}
   */
    this.borderElement = undefined;

    /**
   * @type {HTMLCanvasElement}
   */
    this.canvas = INKIVE.EditorFacade.editor.canvas;
  }

  // Create a new border from given data
  fromData (tableElement, data) {
    const isVertical = Math.abs(data.x1 - data.x2) < 0.1;

    let className = 'table-border ' + (isVertical ? 'table-border-v' : 'table-border-h');
    className += ` index-r-${data.rowIndex} index-c-${data.columnIndex}`;

    this.borderElement = this.canvas.addSvgElementFromJson({
      element: 'line',
      attr: {
        class: className,
        x1: data.x1,
        x2: data.x2,
        y1: data.y1,
        y2: data.y2,
        stroke: data.stroke,
        'stroke-width': data.strokeWidth,
        'stroke-linecap': 'square',
        'stroke-dasharray': (data.strokeDash ? `${data.strokeDash} ${data.strokeDash}` : null)
      }
    });

    tableElement.querySelector('g.table-borders').appendChild(this.borderElement);
  }

  // Use an existing element
  fromElement (borderElement) {
    this.borderElement = borderElement;
  }

  // Set border indices (used for shifing borders on insertion and deletion)
  setIndices (rowIndex, columnIndex) {
    const classList = [...this.borderElement.classList];
    const newClassList = [];

    classList.forEach(className => {
      if (className.startsWith('index-r')) {
        newClassList.push(`index-r-${rowIndex}`);
      } else if (className.startsWith('index-c')) {
        newClassList.push(`index-c-${columnIndex}`);
      } else {
        newClassList.push(className);
      }
    });

    this.borderElement.setAttribute('class', newClassList.join(' '));
  }

  // Stretch the border by delta from (l)eft, (t)op, (r)ight or (b)ottom while keeping the other end fixed
  // Delta can be negative
  resizeFrom (delta, from) {
    let attributeName;

    switch (from) {
      case borderFlagsLeft:
        attributeName = 'x1';
        break;
      case borderFlagsRight:
        attributeName = 'x2';
        break;
      case borderFlagsTop:
        attributeName = 'y1';
        break;
      case borderFlagsBottom:
        attributeName = 'y2';
        break;
    }

    const value = parseFloat(this.borderElement.getAttribute(attributeName));
    this.borderElement.setAttribute(attributeName, value + delta);
  }

  // Move the border in one direction (h or v) by delta
  slideBy (delta, direction) {
    const attributeName = direction === INKIVE.Table.directionVertical ? 'y' : 'x';

    for (let i = 1; i <= 2; i++) {
      const value = parseFloat(this.borderElement.getAttribute(attributeName + i));
      this.borderElement.setAttribute(attributeName + i, value + delta);
    }
  }
}
